/** The Spanish catalogue for the advice band — the wording only. Why each entry exists is argued in `en/hud.ts`. */
export default {
  drone_pick: 'dron en el piso — 4 para levantarlo',
  drone_land: 'PÓSALO para guardarlo · el botón derecho baja',
  drone_walk: 'está posado lejos: acércate para guardarlo',
  drone_cut: '{key} · CORTAR ENLACE — el dron queda aquí y puedes volver a buscarlo',
  drone_pad_blocked: '🛬 No hay lugar para despegar — el cuadrado de adelante está ocupado. Da un paso.',
  drone_lost_crash: '🚁 Te llevaste algo puesto. El aparato quedó donde pegó — ve a buscarlo.',
  drone_lost_battery: '🔋 Sin batería. Bajó solo: camina hasta él y levántalo.',
  drone_lost_rival: '🚁 Te bajaron el dron en el aire. Ahora el chiste es de ellos.',
  map_title_plain: 'Mapa del campo',
  map_close: 'M PARA CERRAR · LA PARTIDA SIGUE',
  map_close_btn: 'Cerrar el mapa',
  map_legend: 'Referencias',
  map_you: 'Tu posición',
  map_structures: 'Estructuras',
  kneeling: 'AGACHÁNDOSE…',
  standing: 'PARÁNDOSE…',
  kneel: 'AGACHADO',
  prone: 'CUERPO A TIERRA',
  proning: 'TIRÁNDOSE AL PISO…',
  stealth: 'SIGILO',
  down: 'ABATIDO — te levantas en un momento',
  out: 'FUERA DE LA RONDA',
  sanctioned: 'SANCIONADO — {s} s',
  fell: 'CAÍDA — {m} m',
  swapping: 'CAMBIANDO…',
  // PROD-CLEANUP: no reader yet — see the English catalogue, which is the key set.
  reloading: 'RECARGANDO…',
  thirsty: 'TE ESTÁS DESHIDRATANDO',
  grenade_ready: 'LATA EN MANO — CLIC PARA LANZAR',
  offline: 'SIN ENLACE — reconectando ({n})',
  reconnected: 'reconectado como #{id} — spawn nuevo, cargador lleno',
  local: 'PRÁCTICA — partida local, no puntúa para récords',
  // The labels of the two field instruments, which are WORDS and not figures.
  wind: 'VIENTO',
  position: 'POSICIÓN',
  // The eight points, clockwise from north. Why each entry exists is argued in `en/hud.ts`.
  compass_n: 'N',
  compass_ne: 'NE',
  compass_e: 'E',
  compass_se: 'SE',
  compass_s: 'S',
  compass_sw: 'SO',
  compass_w: 'O',
  compass_nw: 'NO',

  // ── the link, said twice on purpose ───────────────────────────────────────────────────────────────
  connecting: 'conectando…',
  link_lost: 'se cayó el enlace — reconectando',
  link_stale: 'RECARGA — esta página no puede hablar con este servidor',
  link_stale_note: 'esta página no puede hablar con este servidor — RECARGA (ctrl+shift+R)',
  local_crashed: 'la partida local se cayó ({why}) — recarga',
  field_not_fetched: 'no se pudo bajar el campo ({why}) — reconectando para recibirlo por el socket',
  tab_close_blocked: 'cierre de pestaña bloqueado — sal con ESC y cierra desde la pausa',

  // ── what the band is allowed to carry ─────────────────────────────────────────────────────────────
  running: 'corriendo',
  warnings: 'apercibimientos {n}/{of}',
  impact: 'impacto',

  // ── the can ───────────────────────────────────────────────────────────────────────────────────────
  smoke_note: 'humo {dye} · RUEDA',
  impact_note: 'granada · RUEDA',
  smoke_lit: 'humo {dye} — {s} s',
  smoke_refused: 'HUMO — {reason}',
  smoke_too_many: 'demasiado humo en el campo, espera',
  dye_red: 'rojo',
  dye_yellow: 'amarillo',
  dye_blue: 'azul',
  dye_white: 'blanco',

  // ── refusals the player could not have predicted ──────────────────────────────────────────────────
  no_power: 'SIN FUERZA · {d} m — tu máxima son {max} m',
  climb_refused: 'no se pudo subir · {reason}',
  // La mochila (§189). El refuse llega TIPADO de la autoridad y se dice: un boton que no contesta es
  // indistinguible de uno roto (`shared/inventory.ts ItemRefusal`).
  item_used: 'usaste: {item}',
  item_refused: 'no se pudo usar {item} · {reason}',
  item_name_canteen: 'la cantimplora',
  item_name_binoculars: 'los prismaticos',
  item_name_camo: 'el camuflaje',
  item_name_radio: 'la radio',

  radio_tx_on: 'TRANSMITIENDO',
  radio_tx_push: 'PULSAR PARA HABLAR',
  radio_refused_no_radio: 'no traes radio',
  radio_refused_no_such_channel: 'ese canal no existe',
  radio_refused_no_such_frequency: 'esa frecuencia queda fuera del rango del aparato',
  radio_refused_down: 'estas fuera de la ronda',
  item_not_carried: 'no lo traes',
  item_not_built: 'todavia no hace nada',
  item_already_full: 'no hace falta',
  item_down: 'estas fuera de juego',
  marker_model_note: 'modelo de marcadora no disponible — se dibuja el reemplazo',
  marker_model_notice: 'MODELO DE MARCADORA NO DISPONIBLE — vuelve a elegirla con L',

  // ── the field changing under a live page ──────────────────────────────────────────────────────────
  field_changing: 'campo: {name} — recargando…',
  session_rearmed: 'sesión reiniciada en {name} — recargando…',

  // ── the handshake refusing, said as something to DO ───────────────────────────────────────────────
  refused_stale: 'RECHAZADO — esta página es más vieja que el servicio: RECARGA (ctrl+shift+R){why}',
  refused_full: 'RECHAZADO — la sala está llena: espera un lugar, o empieza una partida individual desde el menú{why}',
  refused_other: 'RECHAZADO — el servicio no aceptó esta página{why}',
  room_open: 'SALA {code} — {seats} lugares. Envía esto: {url}',
  room_peer: '{peer} entró — {how}, {ms} ms para conectar',
  room_no_relay: 'sin relevo disponible — un jugador detrás de CGNAT puede no llegar a conectarse',
  session_elsewhere: 'esta cuenta inició sesión en otro lado — el campo es de ese navegador ahora',
  session_expired: 'tu sesión venció — vuelve a firmar desde el teléfono para entrar de nuevo',
  host_gone: 'SERVIDOR DESCONECTADO — quien hospedaba cerró la sala, así que esta partida terminó. Pídele que la abra de nuevo, o empieza una partida individual desde el menú.',
  third_person_refused: '{key} · este campo se juega desde el ojo',
  flag_take: '🏁 {key} — tomar la bandera de {team}',
};
